import styled from 'styled-components/macro';
import { FormComponentProfile } from '../FormComponentProfile';

export const UserPanelProfile = styled(FormComponentProfile)`
  margin-top: 0;
  margin-bottom: 3.6rem;
`;
